module.exports = __webpack_public_path__ + "img/JM.dbbef169.png";